import { useCallback, useEffect, useMemo } from 'react';

// components
import { Typeform } from '@/components/organisms/Typeform/Typeform';

import {
  GenericFlowProps,
  OnboardingActions,
  OnboardingActionType,
  toGenericOnboarding,
} from '@/components/pages/OnboardingFlow/OnboardingFlow';

export const OnboardingTypeform = toGenericOnboarding(
  ({
    setIsNextDisabled,
    config,
    currentIndex = 0,
    handleClick,
  }: GenericFlowProps<OnboardingTypeformConfigItem>) => {
    return (
      <>
        {config[currentIndex]?.formID && (
          <Typeform
            formID={config?.[0]?.formID}
            isNativeApp={config?.[0]?.isNativeApp}
            onSubmit={() => config?.[0]?.onSubmit(handleClick)}
          />
        )}
      </>
    );
  },
);

export interface OnboardingTypeformConfigItem extends OnboardingActions {
  formID: string;
  isNativeApp?: boolean;
  onSubmit: (handleClick?: (actionType: OnboardingActionType) => void) => void;
}

OnboardingTypeform.displayName = 'OnboardingTypeform';
export default toGenericOnboarding(OnboardingTypeform);
